
import $ from 'jquery';
import Velocity from 'velocity-animate';
import { publish, subscribe, unsubscribe } from 'Util/pubsub';

let $header;
let $nav;
let classes;
let selectors;

let $navItems;
let $navLinks;
let $navSubheadings;
let $navToggle;
let elementsInit = false;

let NavSmall = {
	init: function($elm, selectorList, classList) {
		NavSmall = this;
		$nav = $elm;
		selectors = selectorList;
		classes = classList;

		NavSmall._initElements();
		NavSmall._initSubscriptions();
		NavSmall._initEvents();
	},

	_initElements: function () {
		if (!elementsInit) {
			$header = $(selectors.header);
			$navItems = $nav.find(selectors.navItem);
			$navLinks = $nav.find('.js-megamenu__heading');
			$navSubheadings = $nav.find('.js-megamenu__subheading');
			$navToggle = $('.js-header__nav-toggle');
			elementsInit = true;
		}
	},

	_initSubscriptions: function() {
		subscribe('/nav/searchToggle', NavSmall._closeNav);
		subscribe('/nav/langToggle', NavSmall._closeNav);
	},

	_initEvents: function() {
		$navToggle.on('click', NavSmall._toggleSmallMenu);
		$navLinks.on('click', NavSmall._openSubMenu);
		$navSubheadings.on('click', NavSmall._openSubMenu);
	},

	unbind: function () {
		unsubscribe('/nav/searchToggle', NavSmall._closeNav);
		unsubscribe('/nav/langToggle', NavSmall._closeNav);
		$navToggle.off('click', NavSmall._toggleSmallMenu);
		$navLinks.off('click', NavSmall._openSubMenu);
		$navSubheadings.off('click', NavSmall._openSubMenu);
		NavSmall._resetMenu();
	},

	// close primary nav menu if open
	_closeNav: function () {
		if ($navToggle.attr('aria-expanded') === 'true') {
			$navToggle.trigger('click');
		}
	},

	// publish nav toggle event
	// show/hide primary nav menu dependant on current state
	// toggle class on menu button
	_toggleSmallMenu: function (event) {
		event.preventDefault();
		publish('/nav/navToggle');

		if ($nav.attr('aria-expanded') === 'true') {
			// Closing animation
			Velocity($nav[0], 'slideUp', { 
				duration: 300,
				complete: function() {
					$nav.attr('aria-expanded', false);
					$header.removeClass(classes.headerNavOpen);
					// Collapse all expanded menu items
					$navItems.filter('[aria-expanded="true"]').attr('aria-expanded', false);
					// Close all nested expanded items
					$nav.find('[aria-expanded="true"]').attr('aria-expanded', false);
					publish('/nav/closed');
				}
			});
		} else {
			// Opening animation
			$nav.attr('aria-expanded', true);
			$header.addClass(classes.headerNavOpen);
			publish('/nav/opened');
			Velocity($nav[0], 'slideDown', { duration: 300 });
		}

		if ($navToggle.attr('aria-expanded') === 'true') {
			$navToggle.attr('aria-expanded', false);
		} else {
			$navToggle.attr('aria-expanded', true);
		}

		const title = $navToggle.attr('title');
		const altTitle = $navToggle.attr('data-alt-title');

		$navToggle.attr('title', altTitle);
		$navToggle.attr('data-alt-title', title);
	},


	_openSubMenu: function (event) {
		event.preventDefault();

		const $link = $(this);
		const $item = $link.closest('[aria-expanded]');
		const $siblings = $item.siblings('[aria-expanded="true"]');

		if ($item.attr('aria-expanded') !== 'true') {
			$siblings.attr('aria-expanded', false);
			// Close any nested expanded items in siblings
			$siblings.find('[aria-expanded="true"]').attr('aria-expanded', false);
		}
		if ($item.attr('aria-expanded') === 'true') {
			// Close any nested expanded items within this item when collapsing
			$item.find('[aria-expanded="true"]').attr('aria-expanded', false);
			$item.attr('aria-expanded', false);
		} else {
			$item.attr('aria-expanded', true);
		}
	},

	// collapse nav and any expanded children
	_resetMenu: function() {
		$nav.attr('aria-expanded', false);
		$header.removeClass(classes.headerNavOpen);
		$navItems.attr('aria-expanded', false);
		$navToggle.attr('aria-expanded', false);
	}
};

export { NavSmall };
